import React, { MouseEvent, useState, useEffect } from 'react'
import { Select2 } from '@blueprintjs/select'
import { Checkbox, MenuItem, Position } from '@blueprintjs/core'
import { Button, Flex } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import api from '@api'
import { get } from 'lodash'

interface RegionSelectProps {
  value: string | null
  btnText?: string
  itemDisabled?: (item: string) => boolean
  onChange: (item: string) => void
  buttonProps?: IUIButtonProps
  multi?: boolean
}

const RegionSelector = Select2<string>

export default function RegionSelect({
  value,
  btnText,
  itemDisabled,
  onChange,
  buttonProps = {},
  multi,
}: RegionSelectProps) {
  const regions = useRegions()

  return (
    <RegionSelector
      resetOnSelect
      popoverProps={{ minimal: true, position: Position.BOTTOM }}
      filterable={false}
      items={regions}
      itemRenderer={(region, { handleClick, modifiers }) => (
        <MenuItem
          key={`region-${region}`}
          active={modifiers.active}
          onClick={(e: MouseEvent<HTMLElement>) => {
            if (multi) {
              e.preventDefault()
              onChange(region)
              return
            }
            handleClick(e)
          }}
          text={
            <Flex align="center">
              {multi && <Checkbox checked={itemDisabled && itemDisabled(region)} />}
              {region}
            </Flex>
          }
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        text={value ? value : btnText || 'Select'}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
      />
    </RegionSelector>
  )
}

const useRegions = () => {
  const [companyRegions, setRegions] = useState<string[]>([])

  useEffect(() => {
    api.company.regions().then((regions) => setRegions(regions))
  }, [])
  return companyRegions
}
